/**
 * ClassProfile — UML Class / Object / Package / Profile diagrams.
 * See plans/software-design/domain.md § 3 for grammar and relationship subtypes.
 */

import type { DomainDataProfile } from '../../../core/data-profiles';
import type { DiagramType } from '../../../lib/diagram/registries';

export type ClassNodeType = 'class_class' | 'class_interface' | 'class_enum' | 'class_abstract' | 'class_package';
export type ClassEdgeType = 'extends' | 'implements' | 'composes' | 'aggregates' | 'uses' | 'imports';

export const ClassProfile: DomainDataProfile<ClassNodeType, ClassEdgeType> = {
  domainId: 'class',
  profileVersion: '1.0',
  diagramTypes: ['uml' as DiagramType],
  nodeTypes: ['class_class', 'class_interface', 'class_enum', 'class_abstract', 'class_package'],
  edgeTypes: ['extends', 'implements', 'composes', 'aggregates', 'uses', 'imports'],
  vocabulary: {
    recordSingular: 'Class',
    recordPlural: 'Classes',
    repositoryLabel: 'Package',
    hierarchyLabel: 'Inheritance',
    importAction: 'Import Classes',
    keyColumnHint: 'Class Name',
    commitLabel: 'Push Classes',
    pullLabel: 'Refresh Classes',
    diagramLabel: 'class diagram',
  },
  fieldAliases: {
    name: ['className', 'class'],
    attributes: ['fields', 'properties', 'attrs'],
    methods: ['operations', 'functions'],
    visibility: ['access', 'modifier'],
  },
  requiredProps: ['name'],
  recommendedProps: ['attributes', 'methods'],
  primaryShapeType: 'class_class',
  propsToAttrsMapping: {
    name: 'name',
    attributes: 'attributes',
    methods: 'methods',
    visibility: 'visibility',
    generics: 'generics',
    stereotype: 'stereotype',
  },
  relationshipPackId: 'software-design-relationships',
};
